export default __webpack_public_path__ + "static/SONY_IMX335_Night_thumb-272d8df87db18b68dc15cba1eb00bf2d.webp";